import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Icon from '@material-ui/core/Icon';
import { withRouter } from "react-router";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import * as searchActions from '../Actions/searchActions';
import { withTranslation } from 'react-i18next';

class SearchContainer extends Component {
	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
		this.onFormSubmit = this.onFormSubmit.bind(this);
		this.resetSearch = this.resetSearch.bind(this);
		this.handleKey = this.handleKey.bind(this);
		this.handleCheckboxPending = this.handleCheckboxPending.bind(this);
		this.handleCheckboxOdoo = this.handleCheckboxOdoo.bind(this);
		this.handleCheckboxRating = this.handleCheckboxRating.bind(this);
		this.handleChangeLang = this.handleChangeLang.bind(this);
	}

	onChange(e) {
		this.props.actions.setSearch(e.target.value);
	}
	
	handleKey(e){
//		console.log(this.props.location);
		if (e.keyCode === 13){
			e.stopPropagation();
			e.preventDefault();
			if(this.props.location.pathname=="/orderList" || this.props.location.pathname=="/"){
				window.location.reload();
			}
		}
	}
	
	handleCheckboxPending(e){
		if(this.props.location.pathname=="/orderList" || this.props.location.pathname=="/"){
			this.props.actions.setFilterPending(e.target.checked);
			this.props.actions.setFilterOdoo(false);
			this.props.actions.setFilterRating(false);
			window.location.reload();
		}
	}
	handleCheckboxOdoo(e){
		if(this.props.location.pathname=="/orderList" || this.props.location.pathname=="/"){
			this.props.actions.setFilterOdoo(e.target.checked);
			this.props.actions.setFilterPending(false);
			this.props.actions.setFilterRating(false);
			window.location.reload();
		}
	}
	
	handleCheckboxRating(e){
		if(this.props.location.pathname=="/orderList" || this.props.location.pathname=="/"){
			this.props.actions.setFilterRating(e.target.checked);
			this.props.actions.setFilterPending(false);
			this.props.actions.setFilterOdoo(false);
			window.location.reload();
		}
	}
	
	handleChangeLang(e){
		const {name, value} = e.target;
		this.props.i18n.changeLanguage(value);
	}
	
	resetSearch(e){
		this.props.actions.setSearch("");
		if(this.props.location.pathname=="/orderList" || this.props.location.pathname=="/"){
			window.location.reload();
		}
	}
	
	onFormSubmit(e) {
		e.preventDefault();
	}

	render() {
		//console.log(this.props)
		//console.log(this.props.i18n.language)
		const { t } = this.props;
		//placeholder = "Search..."
		var icon;
		if(this.props.search.searchString){
			icon = <Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: "#F00", cursor: "pointer"}} onClick={this.resetSearch}>&#59393;</Icon>;
		}else{
			icon = <Icon style={{ fontFamily: "tipoecl", fontSize: "26px", color: "#d5dbdb"}}>&#59414;</Icon>;
		}
		let langSwitcher = <div className="col-5"><FormControl>
							<Select
								native
								value={this.props.i18n.language.split("-")[0]}
								onChange={this.handleChangeLang}
								//style={{ color: "#FFF" }}
								className = "lang_selector"
								>
								<option value="ca">Ca</option>
								<option value="es">Es</option>
								<option value="en">En</option>
							</Select>
						</FormControl></div>
		let filterOdoo="";
		let filtreRating="";
		if(this.props.user.role=='ADMIN'){
			filterOdoo=<div className="col-5"><FormControlLabel 
					control={
						<Checkbox
							checked={(typeof this.props.search.filterOdoo!=='undefined') && this.props.search.filterOdoo>0}
							defaultchecked={(typeof this.props.search.filterOdoo!=='undefined') && this.props.search.filterOdoo>0}
							color="primary"
							onChange={this.handleCheckboxOdoo}
						/>
					}
					label="Odoo"
				/></div>
			
			filtreRating=<div className="col-5"><FormControlLabel 
					control={
						<Checkbox
							checked={(typeof this.props.search.filterRating!=='undefined') && this.props.search.filterRating>0}
							defaultchecked={(typeof this.props.search.filterRating!=='undefined') && this.props.search.filterRating>0}
							color="primary"
							onChange={this.handleCheckboxRating}
						/>
					}
					label={t('rating')}
				/></div>
		}
		
		
	    return (
			<span>
			<div className="row align-items-center row justify-content-between">
				<div className="col-10">
					<form onSubmit={this.onFormSubmit}>
					<div className="field">
						<input
						type="text"
						placeholder="Search..."
						onChange={this.onChange}
						onKeyDown={this.handleKey}
						value={this.props.search.searchString}
						/>
					</div>
					</form>
				</div>
				<div className="col-1">
					{icon}
				</div>
			</div>
			<div className="row align-items-center row justify-content-between">
				<div className="col-7">
				<FormControlLabel 
					control={
						<Checkbox
							checked={(typeof this.props.search.filterPending!=='undefined') && this.props.search.filterPending>0}
							defaultchecked={(typeof this.props.search.filterPending!=='undefined') && this.props.search.filterPending>0}
							color="primary"
							onChange={this.handleCheckboxPending}
						/>
					}
					label={t('pending_orders')}
				/>
				</div>
				{filterOdoo}
				{filtreRating}
				{langSwitcher}
			</div>
			</span>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {search: state.search, user: state.user};
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(searchActions, dispatch)};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation() (SearchContainer)));